import { Controller } from "stimulus"

export default class extends Controller {
  static targets = ['bookableSelect', 'bookableUnitSelect']

  toggleBookableSelect() {
    this.bookableSelectTarget.disabled = this.bookableUnitSelectTarget.value !== '';
  }
}
